import { useTranslation } from "react-i18next";
import { EmailTemplatesLibrary } from "@/partner/features/emailTemplates";
import { Meta } from "@/shared/components";

export function EmailTemplatesPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("emailTemplates.pageTitle")} pageType="Partner" />
      <EmailTemplatesLibrary />
    </>
  );
}
